import { appLocale, dateUtils, type hotOffers } from 'shared';

const currentLocale = appLocale.lib.getAppLocale();

const getLocalizedName = (location: hotOffers.LocalizedNames) => {
  return location[`name_${currentLocale}`]
    ? location[`name_${currentLocale}`]
    : location.name;
};

export const getCityData = (result: hotOffers.Result) => {
  return {
    name: getLocalizedName(result.destination.city),
    ...result.destination.city,
  };
};

export const getCountryData = (result: hotOffers.Result) => {
  return {
    name: getLocalizedName(result.destination.country),
    code: result.destination.country.code,
  };
};

export const mapOffersResults = (result: hotOffers.Result) => {
  return {
    ...result,
    destination: {
      ...result.destination,
      city: {
        ...result.destination.city,
        name: getLocalizedName(result.destination.city),
      },
      country: {
        ...result.destination.country,
        name: getLocalizedName(result.destination.country),
      },
    },
    origin: {
      ...result.origin,
      city: {
        ...result.origin.city,
        name: getLocalizedName(result.origin.city),
      },
      country: {
        ...result.origin.country,
        name: getLocalizedName(result.origin.country),
      },
    },
    display_airlines: result.display_airlines.map(airline => ({
      ...airline,
      name: getLocalizedName(airline),
    })),
    dep_at: dateUtils.removeTimezone(result.dep_at),
    arr_at: dateUtils.removeTimezone(result.arr_at),
  };
};
